import { useLocation } from 'react-router-dom';
import { useTheme as useNextTheme } from 'next-themes';
import authService from '@/services/auth.service';
import { isDarkModeAllowed } from '@/lib/dark-mode';

type Theme = 'light' | 'dark' | 'system';

export function useTheme() {
  const location = useLocation();
  const { setTheme, resolvedTheme } = useNextTheme();

  const hasAccessToken = authService.isAuthenticated();
  const darkAllowed = isDarkModeAllowed(location.pathname, hasAccessToken);

  const toggleTheme = () => {
    if (!darkAllowed) return;
    setTheme(resolvedTheme === 'light' ? 'dark' : 'light');
  };

  const setThemeSafe = (nextTheme: Theme) => {
    // Em rotas fora da área logada, não permitimos alternar/forçar dark mode
    if (!darkAllowed && nextTheme === 'dark') return;
    setTheme(nextTheme);
  };

  return {
    theme: (darkAllowed ? (resolvedTheme as Theme) : 'light'),
    setTheme: setThemeSafe,
    toggleTheme,
    isDark: darkAllowed && resolvedTheme === 'dark'
  };
}